import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Vineyard · Experience the Essence</p>
        <h1>Discover the Heart of Virginia's Wine Country</h1>
        <p className="lede">
          Immerse yourself in the rich flavors and breathtaking landscapes of Virginia's finest vineyards. Join us for tastings, tours, and unforgettable experiences.
        </p>
        <div className="cta-row">
          <a href="/tours" target="_blank">
            Explore Our Tours
          </a>
          <a href="/wines" target="_blank" className="secondary">
            View Our Wines
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Experience Unique Tastings</h2>
          <p>
            Savor the diverse flavors of our handcrafted wines, expertly paired with local cuisine in a stunning vineyard setting.
          </p>
        </article>
        <article>
          <h2>Join Our Vineyard Tours</h2>
          <p>
            Take a guided tour through our picturesque vineyards and learn about the winemaking process from our passionate experts.
          </p>
        </article>
        <article>
          <h2>Host Your Event with Us</h2>
          <p>
            Celebrate your special occasions in a beautiful vineyard backdrop, with customizable packages to suit your needs.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;